export const server = process.env.REACT_APP_API_URL + '/api/';
// export const server = 'http://localhost/sta-backendApi/tkd/?adminmods/';
// export const server = 'https://api.tkdsg.com/?adminmods/';
